var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dv-border-box-12',{staticClass:"item-container"},[_c('div',{staticClass:"item-title"},[_vm._v("报警消息")]),_c('div',{attrs:{"id":"scroll-board"}},[_c('dv-scroll-board',{attrs:{"config":_vm.config},on:{"click":_vm.clickEvent}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }